import { Drawer, styled } from "@mui/material";
import { DrawerHeader } from "@common/SimpleDrawer/DrawerHeader";
import { LocationForm } from "@features/locations/components/forms/LocationForm/LocationForm";

interface CreateLocationDrawerProps {
  open: boolean;
  onClose: () => void;
}

// A standalone drawer (stacked over the stock form) for creating a location
// inline while adding stock. Shares the drawer header + form pattern.
export const CreateLocationDrawer = ({
  open,
  onClose,
}: CreateLocationDrawerProps) => (
  <Drawer anchor="right" open={open} onClose={onClose}>
    <SideDrawerContainer>
      <DrawerHeader
        title="Create Location"
        subtitle="Add a place to hold stock"
        onClose={onClose}
      />
      <LocationForm handleClose={onClose} createFromStockView />
    </SideDrawerContainer>
  </Drawer>
);

const SideDrawerContainer = styled("div")(({ theme }) => ({
  width: "100vw",
  position: "relative",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up("lg")]: {
    width: "500px",
  },
}));
